import Button from "Components/Button";
import FlexRow from "Components/FlexRow";
import Modal from "Components/Modal";
import Space from "Components/Space";
import {useTranslation} from "react-i18next";
import {useInvoiceToSettlementOrder} from "../../../Apis/InvoicesApi";
import {IOrderDto} from "../../../Apis/Models/IOrderDto";
import useToasts from "../../../Hooks/UseToasts";
import React from "react";
import {useForm} from "react-hook-form";
import ControlledSelect from "../../../Components/Select/ControlledSelect";
import Select from "Components/Select";
import {useOrders} from "../../../Apis/OrderApi";

type FormData = {
    settlementOrderId: number;
}

interface Props {
    visible: boolean;
    toggleVisible: () => void;
    onSuccess?: () => void;
    order: IOrderDto;
}
const CreateSettlementOrderLineModal = (props: Props) => {

    const { t } = useTranslation();

    const { showSuccessToast } = useToasts();
    const { control, handleSubmit } = useForm<FormData>();

    const { mutateAsync, isLoading } = useInvoiceToSettlementOrder();
    const { data: settlementOrders } = useOrders({ projectId: props.order.projectId, orderType: 'Settlement'})

    const onSubmit = async (data: FormData) => {
        await mutateAsync({
            orderId: props.order.id,
            settlementOrderId: data.settlementOrderId
        });

        showSuccessToast(t('orderInvoicedToSettlementOrderSuccess'));
        
        props.toggleVisible();
        props.onSuccess && props.onSuccess();
    }

    return (
        <Modal title={t('changeOrderStatus')} visible={props.visible} onCancel={() => props.toggleVisible()} modalStyle={{overflow: 'visible'}}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Space size={"large"}>
                    <ControlledSelect control={control} placeholder={t('order')} name={`settlementOrderId`}>
                        {settlementOrders?.items.map((order, index) => <Select.Option key={index} value={order.id} label={`#${order.orderNumber} - ${order.project?.name} ${order.orderTitle}`} />)}
                    </ControlledSelect>

                    <FlexRow justify={"end"}>
                        <Button type={"secondary"} buttonType={"submit"} loading={isLoading} text={t('changeOrderStatus')}/>
                    </FlexRow>
                </Space>
            </form>
        </Modal>
    )
}

export default CreateSettlementOrderLineModal